import styled, { css } from 'styled-components';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

export const FileIcon = styled(InsertDriveFileIcon)(
	({ theme }) => css`
		color: ${theme.palette.text.primary};
		vertical-align: middle;
	`,
);
